import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-top: 100px;
`;

const PageWrapper = (props) => {
  return (
    <Wrapper>
      { props.children }
    </Wrapper>
  );
}

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/ui/PageWrapper.js